module.exports = __webpack_public_path__ + "assets/img/chirp-messages-active.6b99cd5c.svg";